import { SendOutlined } from '@ant-design/icons';
import { Button, Input, Popover } from 'antd';
import { useRouter } from 'next/router';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateTicketFormValues, EditTicketFormValues } from '../../../../types/form';
import { generateTicketFormNameForStorage, getSelectedTabKeyFromUrl } from '../../../store/childStore/tabStore';
import GrispiInputContainer from '../../GrispiInput/GrispiInputContainer';
import QuillGrispiRichTextEditor from '../../QuillGrispiRichTextEditor';

interface Props {
    isDisabled: boolean;
}

const styles = {
    input: { paddingTop: '0.35rem', paddingBottom: '0.35rem', backgroundColor: 'white' }
};

export default function ChatInput({ isDisabled }: Props) {
    const { asPath } = useRouter();
    const { t } = useTranslation('tickets');

    return (
        <Popover placement="top" content={t('chatEndedPopover')} trigger={isDisabled ? 'hover' : []}>
            <GrispiInputContainer noLabel extra={isDisabled ? t('gSocialWarning') : undefined}>
                <Controller<CreateTicketFormValues | EditTicketFormValues, 'comment.body'>
                    name="comment.body"
                    render={({ field: { value, onChange }, fieldState: { error } }) => {
                        if (isDisabled) {
                            return (
                                <Input
                                    id="agent-chat-input-disabled" // to fix border-color css issue on hover/focus etc.
                                    className="agent-chat-input-disabled"
                                    disabled={isDisabled}
                                    placeholder={t('placeholders.chatInput')}
                                    suffix={
                                        <Button
                                            disabled
                                            icon={<SendOutlined />}
                                            shape="circle"
                                            style={{ border: 'none', backgroundColor: 'none' }}
                                            type="text"
                                        />
                                    }
                                    style={styles.input}
                                />
                            );
                        }

                        return (
                            <QuillGrispiRichTextEditor
                                value={value}
                                onChange={onChange}
                                chatInput
                                hideHtmlManipulationsOnToolbar
                                error={!!error?.message}
                                eventListenerKey={generateTicketFormNameForStorage(getSelectedTabKeyFromUrl(asPath))}
                            />
                        );
                    }}
                />
            </GrispiInputContainer>
        </Popover>
    );
}
